
import { Policy } from "@/types";

// Additional policies for demo
export const additionalPolicies: Policy[] = [
  {
    id: "3",
    title: "Code of Conduct",
    description: "Guidelines for appropriate behavior within our platform",
    content: "This Code of Conduct outlines our expectations for participant behavior as well as the consequences for unacceptable behavior.\n\nExpected Behavior: Be respectful and considerate of others. Refrain from demeaning, discriminatory, or harassing behavior and speech. Be mindful of your surroundings and of your fellow participants.\n\nUnacceptable Behavior: Harassment, intimidation, or discrimination in any form will not be tolerated. This includes offensive comments related to gender, sexual orientation, race, religion, disability, or physical appearance. Threats, stalking, and unwelcome physical contact are strictly prohibited.\n\nConsequences: Unacceptable behavior may result in a temporary or permanent ban from our platform without warning.",
    createdAt: "2023-02-05T14:20:00Z",
    updatedAt: "2023-02-05T14:20:00Z",
    reviewDate: "2025-05-21T00:00:00Z",
    ownerId: "5",
    requiredUserTypes: ["admin", "doctor", "nurse", "student", "other"],
    version: "1.0",
    isReviewOverdue: false,
    editLog: [
      {
        editedBy: "Michael Johnson",
        timestamp: "2023-02-05T14:20:00Z",
        changes: "Initial code of conduct creation"
      }
    ],
    reviews: [
      {
        reviewedBy: "Michael Johnson",
        timestamp: "2023-02-05T14:20:00Z"
      }
    ],
    previousVersions: []
  },
  {
    id: "4",
    title: "Data Retention Policy",
    description: "Guidelines for how long we keep your data",
    content: "This Data Retention Policy outlines how long we store different types of data and the procedures for data deletion.\n\nGeneral Principle: We only retain personal data for as long as necessary to fulfill the purposes we collected it for, including legal, accounting, or reporting requirements.\n\nUser Account Data: We retain your account data for the duration of your relationship with us. After account closure, we may retain certain information for up to 12 months to comply with legal obligations.\n\nService Usage Data: Information about how you use our services is retained for 24 months to help us improve our offerings.\n\nCommunications: Email communications and support tickets are retained for 36 months after the last interaction.",
    createdAt: "2023-03-10T09:00:00Z",
    updatedAt: "2023-05-15T11:45:00Z",
    reviewDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString(),
    ownerId: "6",
    requiredUserTypes: ["admin", "doctor"],
    version: "1.1",
    isReviewOverdue: false,
    editLog: [
      {
        editedBy: "Dr. Sarah",
        timestamp: "2023-03-10T09:00:00Z",
        changes: "Initial policy creation"
      },
      {
        editedBy: "Dr. James Wilson",
        timestamp: "2023-05-15T11:45:00Z",
        changes: "Updated retention periods for service usage data"
      }
    ],
    reviews: [
      {
        reviewedBy: "Dr. Sarah",
        timestamp: "2023-03-10T09:00:00Z"
      },
      {
        reviewedBy: "Dr. James Wilson",
        timestamp: "2023-05-15T11:45:00Z"
      }
    ],
    previousVersions: [
      {
        version: "1.0",
        content: "This Data Retention Policy outlines how long we store different types of data.\n\nGeneral Principle: We only retain personal data for as long as necessary.\n\nUser Account Data: We retain your account data for the duration of your relationship with us. After account closure, we may retain information for up to 6 months.\n\nService Usage Data: Information about how you use our services is retained for 12 months.\n\nCommunications: Email communications are retained for 24 months after the last interaction.",
        updatedAt: "2023-03-10T09:00:00Z"
      }
    ]
  },
  {
    id: "5",
    title: "HIPAA Compliance Policy",
    description: "Guidelines for maintaining HIPAA compliance",
    content: "This HIPAA Compliance Policy establishes guidelines to ensure our organization complies with the Health Insurance Portability and Accountability Act (HIPAA).\n\nScope: This policy applies to all employees, contractors, and third parties with access to protected health information (PHI).\n\nSafeguards: We implement administrative, physical, and technical safeguards to protect PHI, including encryption, access controls, and employee training.\n\nPatient Rights: We respect patients' rights to access their health information, request amendments, and receive an accounting of disclosures.\n\nBreach Notification: In case of a data breach involving PHI, we follow federal and state notification requirements.",
    createdAt: "2023-04-18T13:45:00Z",
    updatedAt: "2023-09-22T10:20:00Z",
    reviewDate: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString(),
    ownerId: "7",
    requiredUserTypes: ["admin", "doctor", "nurse"],
    version: "1.3",
    isReviewOverdue: true,
    editLog: [
      {
        editedBy: "Dr. James Wilson",
        timestamp: "2023-04-18T13:45:00Z",
        changes: "Initial policy creation"
      },
      {
        editedBy: "Emily Parker",
        timestamp: "2023-06-30T09:30:00Z",
        changes: "Updated safeguards section with encryption requirements"
      },
      {
        editedBy: "Dr. Emma Taylor",
        timestamp: "2023-09-22T10:20:00Z",
        changes: "Updated breach notification procedures"
      }
    ],
    reviews: [
      {
        reviewedBy: "Dr. James Wilson",
        timestamp: "2023-04-18T13:45:00Z"
      },
      {
        reviewedBy: "Emily Parker",
        timestamp: "2023-06-30T09:30:00Z"
      },
      {
        reviewedBy: "Dr. Emma Taylor",
        timestamp: "2023-09-22T10:20:00Z"
      }
    ],
    previousVersions: [
      {
        version: "1.0",
        content: "This HIPAA Compliance Policy establishes guidelines to ensure our organization complies with HIPAA.\n\nScope: This policy applies to all employees with access to PHI.\n\nSafeguards: We implement basic safeguards to protect PHI.\n\nPatient Rights: We respect patients' rights to access their health information.\n\nBreach Notification: In case of a data breach involving PHI, we follow notification requirements.",
        updatedAt: "2023-04-18T13:45:00Z"
      },
      {
        version: "1.1",
        content: "This HIPAA Compliance Policy establishes guidelines to ensure our organization complies with the Health Insurance Portability and Accountability Act (HIPAA).\n\nScope: This policy applies to all employees and contractors with access to PHI.\n\nSafeguards: We implement administrative and technical safeguards to protect PHI, including encryption and access controls.\n\nPatient Rights: We respect patients' rights to access their health information and request amendments.\n\nBreach Notification: In case of a data breach involving PHI, we follow federal notification requirements.",
        updatedAt: "2023-06-30T09:30:00Z"
      },
      {
        version: "1.2",
        content: "This HIPAA Compliance Policy establishes guidelines to ensure our organization complies with the Health Insurance Portability and Accountability Act (HIPAA).\n\nScope: This policy applies to all employees, contractors with access to protected health information (PHI).\n\nSafeguards: We implement administrative, physical, and technical safeguards to protect PHI, including encryption, access controls, and employee training.\n\nPatient Rights: We respect patients' rights to access their health information, request amendments, and receive an accounting of disclosures.\n\nBreach Notification: In case of a data breach involving PHI, we follow federal and state notification requirements.",
        updatedAt: "2023-08-15T14:10:00Z"
      }
    ]
  }
];
